var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',[_c('svg',{staticClass:"feather",attrs:{"width":_vm.width,"height":_vm.height}},[_c('use',_vm._b({},'use',{'xlink:href':'/feather-sprite.svg#'+_vm.name},false))])])}
var staticRenderFns = []

export { render, staticRenderFns }